var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@apollo/client';
import { RemoveEsigningRecipientDocument } from './mutation.gql';
export const useRemoveEsigningRecipient = () => {
    const [mutate, state] = useMutation(RemoveEsigningRecipientDocument);
    const removeRecipient = (props) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const { variables, onSuccess, onError } = props;
        try {
            const { data } = yield mutate({
                variables,
                update: (cache, result) => {
                    var _a, _b;
                    // eslint-disable-next-line no-underscore-dangle
                    if (((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.removeEsigningRecipient) === null || _b === void 0 ? void 0 : _b.__typename) === 'RemoveEsigningRecipientPayload') {
                        const { id } = result.data.removeEsigningRecipient;
                        cache.modify({
                            id: cache.identify({ id, __typename: 'EsigningRecipient' }),
                            fields(_, { DELETE }) {
                                return DELETE;
                            },
                        });
                    }
                },
            });
            // eslint-disable-next-line no-underscore-dangle
            switch ((_a = data === null || data === void 0 ? void 0 : data.removeEsigningRecipient) === null || _a === void 0 ? void 0 : _a.__typename) {
                case 'RemoveEsigningRecipientPayload':
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data.removeEsigningRecipient);
                    break;
                case 'RemoveEsigningRecipientRejectionList':
                    onError === null || onError === void 0 ? void 0 : onError({ type: 'rejection', reason: data.removeEsigningRecipient.rejections[0].reason });
                    break;
                default:
                    throw new Error();
            }
        }
        catch (e) {
            onError === null || onError === void 0 ? void 0 : onError({ type: 'error', error: e });
        }
    });
    return [removeRecipient, state];
};
